
export default function useHelpers(root) {

  const confirm = (id, callback) => {

    root.$swal({
      title: root.$i18n.t("Are You Sure"),
      text: root.$i18n.t("Do you want to delete this?"),
      showCancelButton: true,
      confirmButtonText: root.$i18n.t('Delete'),
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-danger ml-1',
      },
      buttonsStyling: false,
    }).then(result => {
      if (result.value) {
        callback(id)
      }
    })
  }

  const toaster = (msg, variant = 'success', title = 'Success') => {
    root.$root.$bvToast.toast(
      root.$i18n.t(msg), {
      title: root.$i18n.t(title),
      variant,
      solid: true,
    })
  }


  return {
    confirm,
    toaster
  }


}
